/* eslint-disable max-statements */
/* eslint-disable complexity */
import { request } from '../lib/request';
import type { ApiRequestBody, CreateBinding, CreateBindingParams } from '../types';

const getDeveloperPayload = (options: CreateBindingParams): string => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payload: Record<string, any> = {};

    if (options.mode !== 'default') {
        // eslint-disable-next-line camelcase
        payload.binding_completion_action = options.mode; // временное св-во, TRUST-11613
        // eslint-disable-next-line camelcase
        payload.payment_completion_action = options.mode;
    }

    if (options.theme) {
        payload['css-theme'] = options.theme;
    }

    if (options.modeSuccess !== 'default') {
        // eslint-disable-next-line camelcase
        payload.payment_success_action = options.modeSuccess;
    }

    if (options.template) {
        payload.template = options.template;
    }

    if (options.remoteControl) {
        // eslint-disable-next-line camelcase
        payload.remote_control = options.remoteControl;
    }

    if (options.diehardTemplateTag) {
        // eslint-disable-next-line camelcase
        payload.diehard_template_tag = options.diehardTemplateTag;
    }

    return JSON.stringify(payload);
};

const createPayload = (params: CreateBindingParams): ApiRequestBody => {
    const templateTag = params.isMobile ? 'mobile/form' : 'desktop/form';
    const developerPayload = getDeveloperPayload(params);

    const payload: Record<string, number | string> = {
        template_tag: templateTag,
        developer_payload: developerPayload,
    };

    if (params.lang) {
        payload.lang = params.lang;
    }

    if (params.serviceToken) {
        // eslint-disable-next-line camelcase
        payload.service_token = params.serviceToken;
    }

    if (params.currency) {
        payload.currency = params.currency;
    }

    return payload;
};

// https://a.yandex-team.ru/arcadia/trust/trust/yb_trust_paysys/web.py?rev=r9536216#L1858
export const createBindingApi = async (apiHost: string, params: CreateBindingParams) => {
    const data = await request<CreateBinding>({
        method: 'POST',
        url: `${apiHost}/web/create_binding`,
        body: createPayload(params),
    });

    return data.binding_url;
};
